import React, { useEffect, useMemo, useState } from 'react';
import { Download, Eye, FileText, Loader2, Mail, RefreshCw, Trash2, X,Send } from 'lucide-react';
import { createPortal } from 'react-dom';
import Swal from 'sweetalert2';
import './clientreportsmodal.css';

const BASE = 'https://alcobrakeadmin.com/v3';
const TYPES = ['monthly'];
const get = (obj, ...names) => { const key = Object.keys(obj || {}).find(k => names.some(n => k.toLowerCase() === n.toLowerCase())); return key ? obj[key] : ''; };
const showDate = value => value ? String(value).split('T')[0] : '—';
const apiDate = value => { const iso = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/); if (iso) return `${iso[2]}/${iso[3]}/${iso[1]}`; const d = new Date(value); return Number.isNaN(d.getTime()) ? value : `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}/${d.getFullYear()}`; };

export default function ClientReportsModal({ client, onClose }) {
  const user = JSON.parse(localStorage.getItem('admin_user') || '{}');
  const showReportGenerator = String(user.role).toLowerCase() === 'superadmin'
    || String(get(user, 'dealerId', 'dealer_id')).trim() === '257';
  const clientId = get(client, 'id', 'clientId', 'client_id');
  const clientName = get(client, 'name', 'client', 'clientName') || 'Selected client';
  const installDate = get(client, 'installDate', 'installdate');
  const cbid = get(client, 'cbid', 'controlId');
  const [ranges, setRanges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState('');
  const [preview, setPreview] = useState('');
  const [page, setPage] = useState(1);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [mileage, setMileage] = useState('');
  const [emailDialog, setEmailDialog] = useState(false);
const [selectedEmailReport, setSelectedEmailReport] = useState(null);
const [officers, setOfficers] = useState([]);
const [selectedEmails, setSelectedEmails] = useState([]);
const [emailError, setEmailError] = useState('');
const [sending, setSending] = useState(false);
const allEmails = [...new Set(officers.map(o => o.officeemail).filter(Boolean))];
const selectAll = allEmails.length > 0 && allEmails.every(email => selectedEmails.includes(email));
const [emailLoading, setEmailLoading] = useState(false);

  const load = async () => {
    setLoading(true); setError('');
    try {
      const response = await fetch(`${BASE}/breathalyzer/commonofficer/getreportranges?clientId=${encodeURIComponent(clientId)}&devicemode=interlock`);
      if (response.status === 404) { setRanges([]); return; }
      if (!response.ok) throw new Error();
      const data = await response.json();
      setRanges(Array.isArray(data) ? data : data?.data || []);
    } catch (e) { setError('Reports could not be loaded. Please try again.'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [clientId]);
  useEffect(() => {
    if (!cbid) return;
    fetch(`${BASE}/us/fullclients/getclientmileage?cbid=${encodeURIComponent(cbid)}`)
      .then(response => response.ok ? response.json() : null)
      .then(data => setMileage(data?.mileage || ''))
      .catch(() => setMileage(''));
  }, [cbid]);
  useEffect(() => () => { if (preview) URL.revokeObjectURL(preview); }, [preview]);

  const rows = useMemo(() => [...ranges].sort((a, b) => {
    const dateA = new Date(get(a, 'enddate', 'todate', 'endDate') || get(a, 'startdate', 'fromdate', 'startDate')).getTime() || 0;
    const dateB = new Date(get(b, 'enddate', 'todate', 'endDate') || get(b, 'startdate', 'fromdate', 'startDate')).getTime() || 0;
    return dateB - dateA;
  }).flatMap((range, index) => TYPES.map(type => ({
    key: `${get(range, 'id', 'reportId') || index}-${type}`,
    rangeId: get(range, 'id', 'reportId'),
    from: get(range, 'startdate', 'fromdate', 'startDate'),
    to: get(range, 'enddate', 'todate', 'endDate'),
    sent: ['true', '1'].includes(String(get(range, 'officersent', 'officerSent')).toLowerCase()),
    deleteUrl: get(range, 'delete_url', 'deleteUrl'), type
  }))), [ranges]);
  const pages = Math.max(1, Math.ceil(rows.length / 6));
  const visible = rows.slice((page - 1) * 6, page * 6);
  const urlFor = (row, withMileage = false) =>
  `${BASE}/v2/reports/downloadtxpdf?clientId=${encodeURIComponent(clientId)}&reporttype=monthly&fromdate=${encodeURIComponent(apiDate(row.from))}&todate=${encodeURIComponent(apiDate(row.to))}${
    withMileage ? `&mileage=${encodeURIComponent(mileage)}` : ''
  }`;
  // const urlFor = row => `${BASE}/v2/reports/downloadtxpdf?clientId=${encodeURIComponent(clientId)}&reporttype=monthly&fromdate=${encodeURIComponent(apiDate(row.from))}&todate=${encodeURIComponent(apiDate(row.to))}&mileage=${encodeURIComponent(mileage)}`;

  const openReport = async (row, action) => {
    setBusy(`${row.key}-${action}`);
    try {
      // const response = await fetch(urlFor(row));
      const response = await fetch(
  urlFor(row, row.key === 'custom-monthly')
);
      if (!response.ok) throw new Error();
      if (row.type === 'photos') {
        const data = await response.json();
        if (!data?.zip_url) throw new Error();
        window.open(data.zip_url, '_blank', 'noopener,noreferrer');
      } else {
        const objectUrl = URL.createObjectURL(await response.blob());
        if (action === 'view' && window.innerWidth > 700) setPreview(objectUrl);
        else if (action === 'view') window.open(objectUrl, '_blank', 'noopener,noreferrer');
        else { const a = document.createElement('a'); a.href = objectUrl; a.download = `${clientName}_${row.type}.pdf`.replace(/\s+/g, '_'); a.click(); URL.revokeObjectURL(objectUrl); }
      }
    } catch (e) { Swal.fire('Report unavailable', 'The report could not be opened.', 'error'); }
    finally { setBusy(''); }
  };
const toggleSelectAll = checked => setSelectedEmails(checked ? allEmails : []);
const toggleEmail = email => setSelectedEmails(previous => previous.includes(email) ? previous.filter(value => value !== email) : [...previous, email]);
const openEmailPopup = async report => {
  setSelectedEmailReport(report);
  setEmailDialog(true);
  setEmailLoading(true);
  setEmailError('');
  setOfficers([]);
  setSelectedEmails([]);
  try {
    const response = await fetch(`${BASE}/us/fullclients/getclientoffices?id=${encodeURIComponent(clientId)}`);
    if (!response.ok) throw new Error('Unable to load officers. Please try again.');
    const data = await response.json();
    const list = Array.isArray(data) ? data : data?.data;
    if (!Array.isArray(list)) throw new Error('The officer list could not be read. Please try again.');
    const normalized = list.map((officer, index) => ({
      officeId: get(officer, 'officeId', 'id', 'officerId') || index,
      officeName: get(officer, 'officeName', 'office', 'officer', 'name') || 'Officer',
      officeemail: String(get(officer, 'officeemail', 'officeremail', 'email') || '').trim()
    }));
    setOfficers(normalized);
    setSelectedEmails([...new Set(normalized.map(officer => officer.officeemail).filter(Boolean))]);
  } catch (err) { setEmailError(err.message); }
  finally { setEmailLoading(false); }
};
const sendSelectedEmails = async () => {
  if (!selectedEmailReport || !selectedEmails.length || sending || emailLoading) return;
  setSending(true);
  setEmailError('');
  const delivered = [];
  try {
    const report = selectedEmailReport;
    const response = await fetch(urlFor(report));
    if (!response.ok) throw new Error('The report could not be downloaded. Please try again.');
    const blob = await response.blob();
    if (!blob.size || /json|text\/html/i.test(blob.type)) throw new Error('The server did not return a PDF report.');
    const file = new File([blob], `${clientName}_${report.type}.pdf`.replace(/\s+/g, '_'), { type: 'application/pdf' });
    for (const email of selectedEmails) {
      const formData = new FormData();
      formData.append('to', email);
      formData.append('clientname', clientName);
      formData.append('fromDate', apiDate(report.from));
      formData.append('toDate', apiDate(report.to));
      formData.append('reporttype', 'interlock');
      formData.append('file', file);
      const result = await fetch(`${BASE}/v2/zoho/send`, { method: 'POST', body: formData });
      const responseText = await result.text();
      let data;
      try { data = JSON.parse(responseText); } catch (_) { data = null; }
      if (!result.ok || data?.success === false || data?.status === false || data?.error) throw new Error(`Mail could not be sent to ${email}.`);
      delivered.push(email);
    }
    setEmailDialog(false);
    setSelectedEmailReport(null);
    await Swal.fire({ title: 'Reports sent', text: `Report sent to ${delivered.length} recipient${delivered.length === 1 ? '' : 's'}.`, icon: 'success', customClass: { container: 'report-alert' } });
    await load();
  } catch (err) {
    setSelectedEmails(previous => previous.filter(email => !delivered.includes(email)));
    setEmailError(`${delivered.length ? `Sent to ${delivered.length} recipient(s). Only unsent recipients remain selected. ` : ''}${err.message}`);
  } finally { setSending(false); }
};
  const remove = async row => {
  const result = await Swal.fire({
    title: 'Delete report?',
    text: 'This action cannot be undone.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc2626',
    confirmButtonText: 'Delete'
  });

  if (!result.isConfirmed) return;

  try {
    const url =
      `${BASE}/breathalyzer/commonofficer/deletereportrangespdf` +
      `?clientId=${encodeURIComponent(clientId)}` +
      `&startdate=${encodeURIComponent(apiDate(row.from))}` +
      `&enddate=${encodeURIComponent(apiDate(row.to))}` +
      `&reporttype=interlock`;

    const response = await fetch(url, {
      method: 'GET'
    });

    if (!response.ok) throw new Error();

    await Swal.fire({
      title: 'Deleted',
      text: 'Report deleted successfully.',
      icon: 'success'
    });

    await load();
  } catch (e) {
    Swal.fire(
      'Delete failed',
      'The report could not be deleted.',
      'error'
    );
  }
};
  const customReport = action => {
    if (!fromDate || !toDate) {
      Swal.fire({
  title: 'Select dates',
  text: 'Please select both From Date and To Date.',
  icon: 'info',
  customClass: {
    container: 'report-alert'
  }
});
      return;
    }
    openReport({ key: 'custom-monthly', type: 'monthly', from: fromDate, to: toDate }, action);
  };

  const today = new Date().toISOString().split('T')[0];
  const installMinimum = (() => {
    if (!installDate) return '';
    const parsed = new Date(installDate);
    return Number.isNaN(parsed.getTime()) ? '' : parsed.toISOString().split('T')[0];
  })();

  const handlePostReport = async () => {
  try {
    const response = await fetch(
      "https://alcobrakeadmin.com/v3/us/fullclients/createinterlockreportranges",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          clientId: Number(clientId),
          startdate: apiDate(fromDate),
          enddate: apiDate(toDate),
        }),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.message || "Failed to post report");
    }

    console.log("Report posted:", data);
    alert("Report posted successfully");
    await load();
  } catch (error) {
    console.error("Post report error:", error);
    alert("Failed to post report");
  }
};

  return <div className="modal-overlay client-reports-overlay" onClick={onClose}><section className="client-reports-modal" role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
    <header className="client-reports-header"><div className="client-reports-heading"><span className="client-reports-icon"><FileText size={21} /></span><div><h3>Reports Table</h3><p>{clientName} {installDate && `• Installed ${showDate(installDate)}`}</p></div></div><button className="client-reports-close" onClick={onClose}><X size={20} /></button></header>
    <div className="client-reports-body">
      {showReportGenerator && <div className="client-report-generator">
        <div className="client-report-generator-fields">
          <label><span>From Date</span><input type="date" value={fromDate} min={installMinimum} max={today} onChange={e => { setFromDate(e.target.value); if (toDate && e.target.value > toDate) setToDate(''); }} /></label>
          <label><span>To Date</span><input type="date" value={toDate} min={fromDate || installMinimum} max={today} onChange={e => setToDate(e.target.value)} /></label>
          <label><span>Mileage</span><input type="number" min="0" value={mileage} placeholder="Enter mileage" onChange={e => setMileage(e.target.value)} /></label>
        </div>
        <div className="client-report-generator-actions"><button className="view" onClick={() => customReport('view')} disabled={!!busy}>{busy === 'custom-monthly-view' && <Loader2 size={15} className="is-spinning" />} View PDF</button><button className="download" onClick={() => customReport('download')} disabled={!!busy}>{busy === 'custom-monthly-download' && <Loader2 size={15} className="is-spinning" />} Download PDF</button></div>
      </div>}
      <div className="client-reports-toolbar"><span>{rows.length} available monthly reports</span><button onClick={load} disabled={loading}><RefreshCw size={15} className={loading ? 'is-spinning' : ''} /> Refresh</button></div>
      {loading ? <div className="client-reports-state">Loading reports…</div> : error ? <div className="client-reports-state is-error"><p>{error}</p><button onClick={load}>Try again</button></div> : visible.length ? <div className="client-reports-table-wrap"><table className="client-reports-table"><thead><tr><th>Client</th><th>Month (Range)</th><th>Actions</th></tr></thead><tbody>{visible.map(row => <tr key={row.key}><td>{clientName}</td><td>{showDate(row.from)} <span>–</span> {showDate(row.to)}</td><td><div className="client-report-actions"><button className="view" onClick={() => openReport(row, 'view')} disabled={!!busy}>{busy === `${row.key}-view` ? <Loader2 className="is-spinning" size={15} /> : <Eye size={15} />} View</button><button className="download" onClick={() => openReport(row, 'download')} disabled={!!busy}><Download size={15} /> Download</button>
      {String(get(user, 'dealerId', 'dealer_id')).trim() !== '257' && (
  <button className="email" onClick={() => openEmailPopup(row)} disabled={row.sent}>
    <Mail size={15} /> {row.sent ? 'Sent' : 'Send Email'}
  </button>
)}

{(String(user.role).toLowerCase() === 'superadmin' ||
  String(get(user, 'dealerId', 'dealer_id')).trim() === '257') && !row.sent && (
  <button className="delete" onClick={() => remove(row)}>
    <Trash2 size={15} /> Delete
  </button>
)}
      {/* <button className="email" onClick={() => openEmailPopup(row)} disabled={row.sent}><Mail size={15} /> {row.sent ? 'Sent' : 'Send Email'}</button>{String(user.role).toLowerCase() === 'superadmin' && !row.sent && <button className="delete" onClick={() => remove(row)}><Trash2 size={15} /> Delete</button>} */}
      </div></td></tr>)}</tbody></table></div> : <div className="client-reports-state"><FileText size={34} /><p>No reports found for this client.</p></div>}
      {pages > 1 && <div className="client-reports-pagination"><button disabled={page === 1} onClick={() => setPage(p => p - 1)}>Previous</button><span>Page {page} of {pages}</span><button disabled={page === pages} onClick={() => setPage(p => p + 1)}>Next</button></div>}
    </div>
    {emailDialog && createPortal(
      <div className="client-email-overlay" onClick={e => e.stopPropagation()}>
        <section className="client-email-dialog" role="dialog" aria-modal="true" aria-labelledby="client-email-title" onKeyDown={e => { if (e.key === 'Escape' && !sending && !emailLoading) setEmailDialog(false); }}>
          <header className="client-email-header"><div><Mail size={21} /><h3 id="client-email-title">Email report to officers</h3></div><button aria-label="Close email dialog" disabled={sending || emailLoading} onClick={() => setEmailDialog(false)}><X size={20} /></button></header>
          <div className="client-email-body">
<div className="client-email-summary">
  <strong>{clientName}</strong>
  <span>
    <strong>Monthly report</strong> .{' '}
    <strong>{showDate(selectedEmailReport?.from)} - {showDate(selectedEmailReport?.to)}</strong>
  </span>
</div>            {emailError && <div className="client-email-error" role="alert">{emailError}{!officers.length && <button onClick={() => openEmailPopup(selectedEmailReport)}>Retry loading officers</button>}</div>}
            {emailLoading ? <p role="status">Loading officers?</p> : <>
              <label className="client-email-select-all"><input type="checkbox" autoFocus checked={selectAll} ref={node => { if (node) node.indeterminate = selectedEmails.length > 0 && !selectAll; }} disabled={sending || !allEmails.length} onChange={e => toggleSelectAll(e.target.checked)} />Select all officers<span>{selectedEmails.length} / {allEmails.length}</span></label>
              <div className="client-email-officers">{officers.map((office, index) => <label className="client-email-officer" key={`${office.officeId}-${index}`}><input type="checkbox" disabled={sending || !office.officeemail} checked={selectedEmails.includes(office.officeemail)} onChange={() => toggleEmail(office.officeemail)} /><span><strong>{office.officeName}</strong><small>{office.officeemail || 'No email address available'}</small></span></label>)}{!officers.length && !emailError && <p>No officers are assigned to this client.</p>}</div>
            </>}
          </div>
          <footer className="client-email-actions"><button disabled={sending || emailLoading} onClick={() => setEmailDialog(false)}>Cancel</button><button className="client-email-send" disabled={sending || emailLoading || !selectedEmails.length} onClick={sendSelectedEmails}>{sending ? <Loader2 size={16} className="is-spinning" /> : <Mail size={16} />}{sending ? 'Sending?' : 'Send report'}</button></footer>
        </section>
      </div>, document.body
    )}
    {preview && (
  <div className="client-report-preview">
   <header>
  <strong>Report Preview</strong>

  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
    <button
      onClick={handlePostReport}
      className="post-report-btn"
      title="Send to Officer"
    >
      <Send size={18} />
      <span>Assign to Officer</span>
    </button>

    <button onClick={() => setPreview("")}>
      <X size={18} />
    </button>
  </div>
</header>

    <iframe
      src={preview}
      title="Report preview"
    />
  </div>
  
)}
  </section></div>;
}
